export default __webpack_public_path__ + "static/media/user_profile.d269c2bb.svg";